import React, {Component} from 'react'
import Helmet from 'react-helmet'
import {FormattedMessage, injectIntl} from 'react-intl'
import {Link} from 'react-router-dom'

import cakeTopper1x from './cake-topper@1x.jpg'
import cakeTopper2x from './cake-topper@2x.jpg'
import akakaFalls1x from './eric-rebecca-akaka-falls@1x.jpg'
import akakaFalls2x from './eric-rebecca-akaka-falls@2x.jpg'

class AlbumList extends Component {
  render () {
    return (
      <article>
        <Helmet>
          <title>{this.props.intl.formatMessage({id:'albumListTitle'})}</title>
        </Helmet>

        <hgroup>
          <h1>Rebecca & Eric</h1>
          <h2>
            <FormattedMessage id="photoAlbumsSubtitle" />
          </h2>
        </hgroup>

        <ul className="albums">
          <li>
            <Link to="wedding/" className="hero">
              <img
                srcSet={`${cakeTopper1x} 1024w, ${cakeTopper2x} 2048w`}
                src={cakeTopper1x}
                alt={this.props.intl.formatMessage({id:'cakeTopperAlt'})}
              />

              <label>
                <FormattedMessage id="weddingAlbumTitle" />
              </label>
            </Link>
          </li>

          <li>
            <Link to="honeymoon/" className="hero">
              <img
                srcSet={`${akakaFalls1x} 1x, ${akakaFalls2x} 2x`}
                src={akakaFalls1x}
                alt={this.props.intl.formatMessage({id:'akakaFallsAlt'})}
              />

              <label>
                <FormattedMessage id="honeymoonAlbumTitle" />
              </label>
            </Link>
          </li>
        </ul>
      </article>
    )
  }
}

export default injectIntl(AlbumList)



// WEBPACK FOOTER //
// ./src/AlbumList.js